import { State_update, Types_Msg$4, State_init } from "../ThreeDocs.Client.StateMachine.Crud/CrudComponent.js";
import { CustomShared_get_currentUserInfo_, CustomShared_get_currentRoles_, UsersUpdateArgs, UsersCrudOutbound, CustomShared_get_practices_, CustomShared_get_canCreateUserWithoutAssignedPractices_, CustomShared_get_availableRolesToSelect_, CustomShared, UsersCrudConfig_userVmModelConfig, UsersCrudConfig_userVmViewConfig, UsersCrudConfig_generalViewLayoutConfig } from "./UsersCrudConfig.js";
import { ofArray, map as map_1, singleton, contains, tryHead, empty } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { DefaultActions_terminate, DefaultActions_Types_UpdateArgs$3, DefaultActions_runUpdate, DefaultActions_create, DefaultActions_Types_ChildModel$2, Child$1 } from "../Common/Terminate.js";
import { Msg, Model, childAbsentStrategy } from "./UsersTypes.js";
import { Cmd_batch, Cmd_none, Cmd_map } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { UserRole, UserRole_get_selectableRoles, Permission, isAllowed } from "../ThreeDocs.Models/Security.js";
import { Cmd_OfAsyncWith_either } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { AsyncHelpers_start } from "../fable_modules/Fable.Elmish.4.4.0/prelude.fs.js";
import { publicAuthApi, securedUserManagementApi } from "../Api.js";
import { success, error } from "../ThreeDocs.SharedUI/Toast.js";
import { Common_EmailAddress_create_Z721C83C5, Security_UserInfo$2_toViewModel_Z3F1C2E28, Security_AuthErrorMessage_get_describe } from "../fable_modules/Webbler.Models.1.3.1/Api.fs.js";
import { some, map, defaultArg } from "../fable_modules/fable-library-js.4.25.0/Option.js";
import { find } from "../fable_modules/fable-library-js.4.25.0/Array.js";
import { safeHash, equals } from "../fable_modules/fable-library-js.4.25.0/Util.js";
import { Optic_Set, Optic_Set_op_HatEquals_2170E4F5 } from "../fable_modules/Fable.Aether.1.0.2/Aether.fs.js";
import { Shared_CrudInbound$2 } from "../ThreeDocs.Client.StateMachine.Crud/SharedCrud.js";
import { printf, toText } from "../fable_modules/fable-library-js.4.25.0/String.js";
import { tryTerminate, update as update_1, init as init_1 } from "../EmailChange/EmailChangeState.js";
import { InitArgs } from "../EmailChange/EmailChangeTypes.js";

export function init() {
    const patternInput = State_init(UsersCrudConfig_generalViewLayoutConfig(UsersCrudConfig_userVmViewConfig.viewListItemConfig.listColumns, UsersCrudConfig_userVmModelConfig.isSameItem), UsersCrudConfig_userVmViewConfig, UsersCrudConfig_userVmModelConfig, new CustomShared(empty(), empty(), false, empty(), undefined));
    return [new Model(patternInput[0], new DefaultActions_Types_ChildModel$2(new Child$1(1, []), childAbsentStrategy, "Email Change")), Cmd_map((Item) => (new Msg(8, [Item])), patternInput[1])];
}

export function update(token, userInfo, msg, model) {
    let option, f1, f2, msg_7, matchValue, emailChange, matchValue_1, matchValue_2, msg_2, msg_3;
    switch (msg.tag) {
        case 2:
            if (isAllowed(new Permission(3, []))(userInfo.roles)) {
                return [model, Cmd_OfAsyncWith_either((x) => {
                    AsyncHelpers_start(x);
                }, securedUserManagementApi(token).getUsers, undefined, (Item_6) => (new Msg(3, [Item_6])), (Item_7) => (new Msg(0, [Item_7])))];
            }
            else {
                return [model, Cmd_none()];
            }
        case 3:
            if (msg.fields[0].tag === 1) {
                return [model, error(Security_AuthErrorMessage_get_describe()(msg.fields[0].fields[0]))];
            }
            else {
                let updateStorageCmd;
                const availableRoles = defaultArg((option = tryHead(find((user) => (user.id === userInfo.id), msg.fields[0].fields[0]).roles), map(UserRole_get_selectableRoles(), option)), empty());
                const canCreateEmpty = contains(new UserRole(0, []), availableRoles, {
                    Equals: equals,
                    GetHashCode: safeHash,
                });
                const msg_4 = new Msg(8, [new Types_Msg$4(2, [new Shared_CrudInbound$2(4, [(f1 = Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_availableRolesToSelect_())(availableRoles), (f2 = Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_canCreateUserWithoutAssignedPractices_())(canCreateEmpty), (arg_6) => f2(f1(arg_6))))])])]);
                updateStorageCmd = singleton((dispatch_3) => {
                    dispatch_3(msg_4);
                });
                const msg_5 = new Msg(8, [new Types_Msg$4(2, [new Shared_CrudInbound$2(0, [map_1(Security_UserInfo$2_toViewModel_Z3F1C2E28, ofArray(msg.fields[0].fields[0]))])])]);
                return [model, Cmd_batch(ofArray([singleton((dispatch_4) => {
                    dispatch_4(msg_5);
                }), updateStorageCmd]))];
            }
        case 4:
            return [model, (msg_7 = (new Msg(8, [new Types_Msg$4(2, [new Shared_CrudInbound$2(4, [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_practices_())(msg.fields[0])])])])), singleton((dispatch_5) => {
                dispatch_5(msg_7);
            }))];
        case 6:
            return [model, (matchValue = model.emailChange.child, (matchValue.tag === 0) ? ((emailChange = matchValue.fields[0], (matchValue_1 = Common_EmailAddress_create_Z721C83C5(emailChange.currentEmail), (matchValue_2 = Common_EmailAddress_create_Z721C83C5(emailChange.newEmail), (matchValue_1.tag === 1) ? error("The user\'s current email is invalid. Please try reloading the page") : ((matchValue_2.tag === 1) ? error("The new email is invalid. Please enter a valid email address.") : Cmd_OfAsyncWith_either((x_2) => {
                AsyncHelpers_start(x_2);
            }, publicAuthApi.requestEmailChangeTokenEmail, [emailChange.currentEmail, emailChange.newEmail], (Item_17) => (new Msg(7, [Item_17])), (Item_18) => (new Msg(0, [Item_18])))))))) : error("An email change component has not been created yet. Please try reloading the page."))];
        case 7:
            if (msg.fields[0].tag === 1) {
                return [model, error(Security_AuthErrorMessage_get_describe()(msg.fields[0].fields[0]))];
            }
            else {
                return [model, Cmd_batch(ofArray([success("A confirmation email has been sent to the user\'s current email address"), singleton((dispatch_6) => {
                    dispatch_6(new Msg(10, []));
                })]))];
            }
        case 5:
            if (msg.fields[0].tag === 2) {
                return [model, singleton((dispatch_7) => {
                    dispatch_7(new Msg(2, []));
                })];
            }
            else {
                return [model, Cmd_none()];
            }
        case 0: {
            console.error(some(toText(printf("Error: %O"))(msg.fields[0])));
            return [model, Cmd_none()];
        }
        case 8:
            if (msg.fields[0].tag === 1) {
                switch (msg.fields[0].fields[0].tag) {
                    case 1:
                        return [model, error("An unexpected error occurred. Please try again.")];
                    case 2: {
                        const createdEmailChange = init_1(new InitArgs(msg.fields[0].fields[0].fields[0]));
                        const patternInput = DefaultActions_create(createdEmailChange[0], createdEmailChange[1], model.emailChange);
                        return [new Model(model.UserCrudModel, patternInput[0]), Cmd_map((Item_19) => (new Msg(9, [Item_19])), patternInput[1])];
                    }
                    case 3:
                        return [model, Cmd_OfAsyncWith_either((x_3) => {
                            AsyncHelpers_start(x_3);
                        }, securedUserManagementApi(token).changeUserLockoutStatus, [msg.fields[0].fields[0].fields[0], msg.fields[0].fields[0].fields[1]], (arg_11) => (new Msg(8, [new Types_Msg$4(1, [new UsersCrudOutbound(4, [arg_11])])])), (Item_23) => (new Msg(0, [Item_23])))];
                    case 4:
                        if (msg.fields[0].fields[0].fields[0].tag === 1) {
                            return [model, error(Security_AuthErrorMessage_get_describe()(msg.fields[0].fields[0].fields[0].fields[0]))];
                        }
                        else {
                            return [model, Cmd_batch(ofArray([success("Successfully changed user lockout status"), singleton((dispatch_8) => {
                                dispatch_8(new Msg(2, []));
                            }), singleton((dispatch_9) => {
                                dispatch_9(new Msg(8, [new Types_Msg$4(2, [new Shared_CrudInbound$2(2, [(_arg) => undefined])])]));
                            })]))];
                        }
                    default:
                        return [model, error(Security_AuthErrorMessage_get_describe()(msg.fields[0].fields[0].fields[0]))];
                }
            }
            else {
                const patternInput_1 = State_update(new UsersUpdateArgs(token), msg.fields[0], model.UserCrudModel);
                return [new Model(patternInput_1[0], model.emailChange), Cmd_map((Item_27) => (new Msg(8, [Item_27])), patternInput_1[1])];
            }
        case 9:
            if (msg.fields[0].chainedMsg.tag === 0) {
                const patternInput_2 = DefaultActions_runUpdate(new DefaultActions_Types_UpdateArgs$3((msg_15, model_2) => {
                    if (msg_15.tag === 1) {
                        return [model_2, Cmd_none()];
                    }
                    else {
                        return update_1(undefined, msg_15.fields[0], model_2);
                    }
                }, model), model.emailChange, msg.fields[0]);
                return [new Model(model.UserCrudModel, patternInput_2[0]), Cmd_map((Item_28) => (new Msg(9, [Item_28])), patternInput_2[1])];
            }
            else {
                return [model, Cmd_none()];
            }
        case 10: {
            const patternInput_3 = DefaultActions_terminate(tryTerminate, model.emailChange);
            return [new Model(model.UserCrudModel, patternInput_3[0]), Cmd_batch(ofArray([Cmd_map((Item_29) => (new Msg(9, [Item_29])), patternInput_3[1]), singleton((dispatch_10) => {
                dispatch_10(new Msg(2, []));
            })]))];
        }
        default:
            return [model, Cmd_batch(ofArray([singleton((dispatch) => {
                dispatch(new Msg(2, []));
            }), (msg_2 = (new Msg(8, [new Types_Msg$4(2, [new Shared_CrudInbound$2(4, [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_currentRoles_())(userInfo.roles)])])])), singleton((dispatch_1) => {
                dispatch_1(msg_2);
            })), (msg_3 = (new Msg(8, [new Types_Msg$4(2, [new Shared_CrudInbound$2(4, [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_currentUserInfo_())(userInfo)])])])), singleton((dispatch_2) => {
                dispatch_2(msg_3);
            }))]))];
    }
}

